import { api } from "../api";

type TicketRequestType = {
    id: number;
    name: string;
    description: string;
    typeId: number;
    gravityId: number;
    files: Array<any>;
    departmentId: number;
};

/**
 * ticketUpdateById - Function that updates on database an existing ticket by id   
 * /tickets/{id}   
 * method put  
 * @async-function
 */
const ticketUpdateById = async (token: string, model: TicketRequestType, id: number) => {
    const response = await api.put(
        `/tickets/${id}`, {
            ...model
        }, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
    );
    return response;
};

export default ticketUpdateById;